import React, { ReactNode } from "react";

interface BaseCardProps {
  title?: string;
  icon?: ReactNode;
  children: ReactNode;
}

export default function BaseCard({ title, icon, children }: BaseCardProps) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-gradient-to-r from-blue-50 to-white p-5 shadow-md hover:shadow-lg transition-shadow duration-200 mb-2"> 
            {(title || icon) && (
                <div className="mb-2 flex items-center gap-2 border-b border-gray-300 pb-1">
                {icon && <div className="text-blue-500">{icon}</div>}
                {title && <h2 className="text-base font-semibold text-gray-800">{title}</h2>}
                </div>
            )}
            <div>{children}</div> 
    </div>    
  );
}
